import { render, staticRenderFns } from "./internalAnnouncementContent.vue?vue&type=template&id=f0bd009c&"
import script from "./internalAnnouncementContent.vue?vue&type=script&lang=js&"
export * from "./internalAnnouncementContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports